export enum BusinessUnitEnum {
    DOTA = 'DOTA',
    DEMEA = 'DEMEA'
}